import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue'
import { layer } from '@layui/layer-vue'
import { allUser, disableUsers,allRole,addUser,allPlatform,adminOneClickLogin} from '../../../api'
import { setToken,setUserName } from '../../../utils/auth' 


export default /*#__PURE__*/_defineComponent({
  __name: 'userList',
  setup(__props) {

const platformArr = ref([]);

//平台
const getAllPlatform = () => { 
var data = {};
allPlatform(JSON.stringify(data)).then((res: any) => { 
  if (res != "" && res.code == 0) {
    platformArr.value = res.data; 
  } else {
    platformArr.value = []; 
  }
})
}

getAllPlatform();



const roleArr1 = ref([]);
const roleArr2 = ref([]);

//角色
const getAllRole= () => {
  var data = {};
  allRole(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      roleArr1.value = res.data;
      roleArr1.value.forEach(role => {
          if (role.parentId == 0) {
            roleArr2.value.push(role);
          }
        });
    } else {
      roleArr1.value = [];
    }
  })
}
getAllRole();

 

const search = reactive({
  key: "",
  state: 0
})


const loading = ref(false);
const dataSource = ref([]);
const selectedKeys = ref([]);
const page = reactive({ current: 1, limit: 10, total: 0 });
const columns = ref([
  { title: "账号", key: "userName", align: "center" },
  { title: "角色", key: "roleStr", align: "center" },
  { title: "平台", key: "platform", align: "center" },
  { title: "状态", key: "state", align: "center", customSlot: "state" }, 
  { title: "备注", key: "remark", align: "center" , ellipsisTooltip: true},
  { title: "添加时间", key: "addTime", align: "center" },
  { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center", width: "160px" }
]);


const getAllAdminUser = () => {
  loading.value = true;
  var data = { "page": page.current, "limit": page.limit, "key": search.key, "state": search.state };
   allUser(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      dataSource.value = res.data;
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })
}
//获取数据
getAllAdminUser();


const change = (page: any) => {
  getAllAdminUser();
}

const sortChange = (key: any, sort: any) => {
  layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
}

//禁用或者开启
const changedelFlag = (row: any) => {
  var data = { "key": row.userId, "id": row.state };
  disableUsers(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      getAllAdminUser();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}

//查询接口
const searchUser = () => {
  page.current = 1;
  getAllAdminUser();
}

const user = reactive({
  userId: "",
  userName: "",
  password: "",
  roleId: 0,
  remark: "",
  platformId:0,
 
})


const updateUser = (row: any) => {
  user.userId = row.userId;
  user.userName = row.userName;
  user.password = "";
  user.roleId = row.roleId;
  user.remark = row.remark; 
  user.platformId = row.platformId; 
  isDisabled.value = true;
  visible11.value = !visible11.value;
}

const layFormRef11 = ref();

const visible11 = ref(false);

const isDisabled = ref(false);

const changeVisible11 = () => {
  user.userId = "";
  user.userName = "";
  user.password = "";
  user.roleId = 0;
  user.remark = "";
  user.platformId = 0; 
 
  isDisabled.value = false;
  visible11.value = !visible11.value;
}

const action11 = ref([
  {
    text: "确认",
    callback: () => {
      addUser(JSON.stringify(user)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllAdminUser();
          visible11.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      visible11.value = false;
    }
  }
])


//一键登录
const  oneClickLogin=(row: any)=>{ 
  var data={"key":row.userId}; 
  adminOneClickLogin(JSON.stringify(data)).then((res: any) => {
    if (res!=""&&res.code == 0) { 
            setUserName(row.userName);
            setToken(res.data);
            layer.msg("登录成功", { icon : 1, time: 1000})
            window.location.reload();
        } 
      })
 
}
 

return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "账号",
                      prop: "key",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入账号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "角色",
                      prop: "state",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select, {
                          modelValue: search.state,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.state) = $event)),
                          placeholder: "请选择"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_select_option, {
                              value: 0,
                              label: "全部"
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleArr1.value, (role) => {
                              return (_openBlock(), _createBlock(_component_lay_select_option, {
                                value: role.id,
                                label: role.title
                              }, null, 8, ["value", "label"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: changeVisible11,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[2] || (_cache[2] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  state: _withCtx(({ row }) => [
                    _createVNode(_component_lay_switch, {
                      "model-value": row.state == 0 ? true : false,
                      onChange: ($event: any) => (changedelFlag(row)),
                      "onswitch-text": "正常",
                      "unswitch-text": "禁用"
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updateUser(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "danger",
                      onClick: ($event: any) => (oneClickLogin(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("一键登录")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['400px', '530px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: user,
            ref_key: "layFormRef11",
            ref: layFormRef11,
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "账户",
                prop: "userName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: user.userName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.userName) = $event)),
                    disabled: isDisabled.value,
                    placeholder: "请输入账号"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "密码",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: user.password,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.password) = $event)),
                    type: "password",
                    placeholder: "无需修改请置空"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "角色",
                prop: "roleId",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: user.roleId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user.roleId) = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleArr2.value, (role) => {
                        return (_openBlock(), _createBlock(_component_lay_select_option, {
                          value: role.id,
                          label: role.title
                        }, null, 8, ["value", "label"]))
                      }), 256))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "推广平台",
                prop: "platformId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: user.platformId,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((user.platformId) = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformArr.value, (platform) => {
                        return (_openBlock(), _createBlock(_component_lay_select_option, {
                          value: platform.id,
                          label: platform.name
                        }, null, 8, ["value", "label"]))
                      }), 256))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "备注",
                prop: "generalRemark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入备注",
                    modelValue: user.remark,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((user.remark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})